import { Modal, Button } from "react-bootstrap";

export const CreateUnitModal = ({ show, location, onClose, onConfirm, disabled }) => {
  return (
    <Modal show={show} onHide={onClose} centered className="custom-modal">
      <Modal.Header closeButton>
        <Modal.Title>Create New Unit</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="white-font font-14 fw-normal">
          Do you want to create a new unit at {location?.address}?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-secondary-custom p-2" onClick={onClose}>
          No
        </Button>
        <Button
          className="btn btn-primary-custom p-2"
          onClick={() => onConfirm(location)}
          disabled={disabled}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
